import React, { useState } from "react";
import { Section, EmptyState } from "../shared";
import AuditEntry from "./AuditEntry";
import { getMcpAudit } from "../../../api/mcpApi";
import { toast } from "react-hot-toast";

export default function ActivitySection({ entries, onRefresh }) {
  const [loadingMore, setLoadingMore] = useState(false);
  const [allEntries, setAllEntries] = useState(entries || []);
  const [hasMore, setHasMore] = useState(true);

  React.useEffect(() => {
    setAllEntries(entries || []);
  }, [entries]);

  const handleLoadMore = async () => {
    setLoadingMore(true);
    try {
      const data = await getMcpAudit(50, allEntries.length);
      const newEntries = data.entries || [];
      if (newEntries.length < 50) setHasMore(false);
      setAllEntries((prev) => [...prev, ...newEntries]);
    } catch {
      toast.error("Failed to load more entries");
    } finally {
      setLoadingMore(false);
    }
  };

  return (
    <Section title="Activity" subtitle="Agent activity audit log" id="mcp-activity">
      <div className="mcp-activity-header">
        <button
          type="button"
          className="mcp-btn mcp-btn-sm"
          onClick={onRefresh}
        >
          Refresh
        </button>
      </div>

      {allEntries.length === 0 ? (
        <EmptyState
          icon={
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" />
              <rect x="9" y="3" width="6" height="4" rx="1" />
            </svg>
          }
          title="No agent activity yet"
          description="Activity from AI agents using your API keys will appear here."
        />
      ) : (
        <>
          <div className="mcp-audit-list">
            {allEntries.map((entry, idx) => (
              <AuditEntry key={entry.id || idx} entry={entry} />
            ))}
          </div>
          {hasMore && (
            <button
              type="button"
              className="mcp-btn mcp-btn-load-more"
              onClick={handleLoadMore}
              disabled={loadingMore}
            >
              {loadingMore ? "Loading..." : "Load more"}
            </button>
          )}
        </>
      )}
    </Section>
  );
}
